export const FEATURE_FLAG_SHOW_CREATE_BUTTON = 'show-create-button';
export const FEATURE_FLAG_SHOW_SEARCH_TOPICS_CARD = 'show-search-topics-card';
